const constants = {
  MASQUERADE_MODE_STATE_KEY: 'MASQUERADE_MODE',
  MASQUERADE_MODE_SET_OR_UPDATE: 'MASQUERADE_MODE_SET_OR_UPDATE',
  MASQUERADE_MODE_UNSET: 'MASQUERADE_MODE_UNSET',
  MASQUERADE_MODE_SETTINGS_SET: 'MASQUERADE_MODE_SETTINGS_SET',
  MASQUERADE_MODE_SETTINGS_UNSET: 'MASQUERADE_MODE_SETTINGS_UNSET',
  NUMBER_INDICATOR_SET_OR_UPDATE: 'NUMBER_INDICATOR_SET_OR_UPDATE',
};

export default constants;
